import { render, staticRenderFns } from "./reginDetail.vue?vue&type=template&id=1391f6a0"
import script from "./reginDetail.vue?vue&type=script&lang=js"
export * from "./reginDetail.vue?vue&type=script&lang=js"
import style0 from "./reginDetail.vue?vue&type=style&index=0&id=1391f6a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports